function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgChat = function SvgChat(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, ["svgRef"]);
  return React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef
  }, props), React.createElement("circle", {
    "data-name": "Ellipse 2",
    cx: 24,
    cy: 24,
    r: 24,
    style: {
      fill: "#ff6452"
    }
  }), React.createElement("path", {
    "data-name": "Path 897",
    d: "M14 2a12 12 0 0 0-9.292 19.595l-2.356 2.357A1.2 1.2 0 0 0 3.2 26H14a12 12 0 1 0 0-24z",
    transform: "translate(10 10)",
    style: {
      fill: "#fff"
    }
  }), React.createElement("circle", {
    "data-name": "Ellipse 3",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(22.5 22)",
    style: {
      fill: "#ff6452"
    }
  }), React.createElement("circle", {
    "data-name": "Ellipse 4",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(17.611 22)",
    style: {
      fill: "#ff6452"
    }
  }), React.createElement("circle", {
    "data-name": "Ellipse 5",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(27.389 22)",
    style: {
      fill: "#ff6452"
    }
  }));
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgChat, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chat.1ca299ae.svg";
export { ForwardRef as ReactComponent };